import { Link } from "react-router-dom";
import "@/components/paw/GiftsPage.css";
import "@/components/paw/GiftsPage.mobile.css";
import SiteFooter from "@/components/paw/SiteFooter";
import PublicTopNav from "@/components/paw/PublicTopNav";

const GIFTS_DESKTOP_ARTWORK = "/desktop-gifts.png";
const GIFTS_REPORT_SOURCE = "/Gifts.png";

export default function GiftsPage() {
  return (
    <div className="gifts-page" data-testid="gifts-page">
      <main className="gifts-mobile-layout">
        <PublicTopNav />

        <section className="gifts-mobile-copy" aria-labelledby="gifts-mobile-heading">
          <h1 id="gifts-mobile-heading">A Paw-some Report Makes a Great Gift!</h1>
          <p>Want to order a personalized Paw-Some<br />Report for someone special?</p>
          <p className="gifts-mobile-coming">Online gift ordering is coming soon.</p>
          <p>For now, email us and we&rsquo;ll help arrange the<br />order, including who will provide the pet<br />photos and receive the finished report.</p>
          <p className="gifts-mobile-email">Email us at <a href="mailto:hello@pawsomereports.com">hello@pawsomereports.com</a></p>
        </section>

        <section className="gifts-mobile-report-section" aria-label="Sample Paw-some Report for Crunchy">
          <div className="gifts-mobile-report-crop" role="img" aria-label="Crunchy's personalized Paw-some Report">
            <img src={GIFTS_REPORT_SOURCE} alt="" aria-hidden="true" />
          </div>
          <Link to="/order" className="gifts-mobile-order-button" aria-label="Order Now">ORDER NOW</Link>
        </section>
      </main>

      <main className="gifts-artwork gifts-desktop-layout">
        <img src={GIFTS_DESKTOP_ARTWORK} alt="A Paw-some Report Makes a Great Gift" />
        <PublicTopNav overlay />
        <a href="mailto:hello@pawsomereports.com" className="gifts-art-link gifts-art-email" aria-label="Email Paw-some Reports" />
      </main>
      <SiteFooter />
    </div>
  );
}
